<script>
    import {email, required } from 'vuelidate/lib/validators';
    import ButtonNormal from '@/components/buttons/ButtonNormal.vue';
    import RandomPasswordGenerator from '@/services/RandomPasswordGenerator';
    export default {
        name: 'WizardFirstUserFirstStep',
        components: {
            ButtonNormal,
        },
        props: {
            title: String,
            description: String,
            image: String,
        },
        data() {
            return {
                form: {
                    firstName: '',
                    familyName: '',
                    email: '',
                    password: RandomPasswordGenerator._randomPassword(8),
                },
                isSubmitted: false,
            };
        },
        validations: {
            form: {
                firstName: {
                    required,
                },
                familyName: {
                    required,
                },
                email: {
                    email,
                    required,
                },
            },
        },
        methods: {
            getImage(name) {
                const images = require.context(
                    '../../../assets/wizard',
                    false,
                    /\.svg$/,
                );
                return images('./' + name + '.svg');
            },
            validateMail(mail) {
                const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(mail).toLowerCase());
            },
            submit() {
                this.isSubmitted = true;
                if (!this.$v.form.$invalid) {
                    this.$emit('on_next', this.form);
                } else {
                    this.$toasted.global.starface_error({
                        message: 'Bitte fülle alle Felder korrekt aus.',
                        icon: 'USER'
                    });
                }
            },
        },
    };
</script>

<template>
    <div class="wizard-content-step">
        <div class="wizard-content-header">
            <div class="description">
                <h1>{{title}}</h1>
                <p v-html="description"></p>
            </div>
        </div>
        <div class="blocks">
            <div class="block grid-column-1">
                <div class="image">
                    <img :src="getImage(image)" atl="Wizard image" />
                </div>
            </div>
            <div class="block grid-column-2">
                <form class="form">
                    <div class="form-group">
                        <label for="firstName">Vorname</label>
                        <input type="text" name="firstName" id="firstName" class="form-control" v-bind:class="{ 'has-error': isSubmitted && $v.form.firstName.$invalid }" v-model="form.firstName" required/>
                        <span class="error" v-if="isSubmitted && $v.form.firstName.$invalid">Bitte gebe einen Vornamen ein.</span>
                    </div>
                    <div class="form-group">
                        <label for="familyName">Nachname</label>
                        <input type="text" name="familyName" id="familyName" class="form-control" v-bind:class="{ 'has-error': isSubmitted && $v.form.familyName.$invalid }" v-model="form.familyName" required/>
                        <span class="error" v-if="isSubmitted && $v.form.familyName.$invalid">Bitte gebe einen Nachnamen ein.</span>
                    </div>
                    <div class="form-group">
                        <label for="email">E-mail</label>
                        <input type="text" name="email" id="email" class="form-control" v-bind:class="{ 'has-error': isSubmitted && $v.form.email.$invalid}" @input="$v.form.email.$touch()" v-model="form.email" required/>
                        <span class="error" v-if="isSubmitted && $v.form.email.$invalid">Bitte gebe eine korrekte E-Mail-Adresse ein.</span>
                    </div>
                </form>
            </div>
        </div>
        <div class="blocks one-column">
            <div class="actions center">
                <div class="close-wizard">
                    <router-link class="" :to="'/'" tag="a">
                        Wizard abbrechen
                    </router-link>
                </div>
                <ButtonNormal @onClick="submit" buttonTitle="Rufnummer auswählen" cssClass="btn btn-primary" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import './step.scss';
    @import '../../../assets/scss/form.scss';
    .error {
        font-size: 12px;
        font-weight: 600;
        text-align: left;
        color: $red;
    }
    
    .has-error {
        border-color: #f54d00;
    }
</style>
